module.exports = __webpack_public_path__ + "assets/img/00018.8f3b8896.png";